// AUTO-GENERATED. Do not edit.
export const BRANCH_NAME = 'main';
